<template>
    <div class="selection">
        <div v-for="option in options" :class="{ selected: isSelected(option) }" @click="handleClick(option)">{{ option.label }}</div>
    </div>
</template>

<script>
export default {
    props: {
        options: { type: Array, required: true },
        value: { type: [String, Number], required: false },
        bitmap: { type: Boolean, default: false }
    },
    methods: {
        isSelected(option) {
            if (!this.bitmap) {
                return this.value == option.value;
            } else {
                return (this.value & option.value) != 0;
            }
        },
        handleClick(option) {
            if (!this.bitmap) {
                return this.$emit('input', option.value);
            } else {
                return this.$emit('input', option.value ^ this.value);
            }
        }
    }
}
</script>

<style lang="less" scoped>
.selection
{
    display: inline-flex;
    flex-direction: row;
    background-color: white;
    font-size: 80%;

    div
    {
        padding: 4px 8px;
    }
    div:not(:last-of-type)
    {
        border-right: 2px solid #eee;
    }
}
.selected
{
    background-color: #66c8ff;
}
</style>
